module.exports = __webpack_public_path__ + "2d82dd4d462458d08689e6b266bb966e.jpg";